import React from 'react';
import { MdDashboard } from 'react-icons/md';
import { CgProfile } from 'react-icons/cg';
import { FaBook, FaListAlt, FaWallet, FaGlobe, FaBell } from 'react-icons/fa';
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const navConfig = [
  {
    title: 'Dashboard',
    path: '/dashboard/app',
    icon: <MdDashboard />,
  },
  {
    title: 'Node Monitor',
    icon: icon('ic_analytics'),
    path: '/dashboard/monitors',
  },
  {
    title: 'API Monitor',
    icon: <FaGlobe />,
    path: '/dashboard/domainMonitors',
  },
  // {
  //   title: "Alert",
  //   icon: <FaBell />, // Use FaBell from react-icons for "Alert."
  //   path: "/dashboard/alerts"
  // },
  {
    title: 'Wallet',
    icon: <FaWallet />,
    path: '/dashboard/wallet',
  },
  {
    title: 'Profile',
    icon: <CgProfile />,
    path: '/dashboard/profile',
  },
  {
    title: 'Alerts',
    icon: <FaBell />,
    path: '/dashboard/alert',
  },
  {
    title: 'Subscription',
    icon: <FaListAlt />,
    path: '/dashboard/subscription',
  },
  {
    title: 'Documentation',
    icon: <FaBook />,
    path: '/dashboard/documentation',
  }
];

export default navConfig;
